import { FC, useEffect, useReducer, useState } from 'react'
import React from 'react'
import * as pageUtils from './__details.utils'
import Text from '@components/ui/text'
import * as pageUtilsForm from '@components/requestForms/__forms.utils'

const DemandeUrbanismeAuComptoirFormDetails: FC<pageUtils.Props> = ({
	pageAssets,
	request
}) => {
	return (
		<>
			{/* Question 1 */}
			<div>
				{/* <strong>{pageAssets.request_form_what_would_you_like_to_do}</strong>
				<br /> */}
				{/* <span>
					{getLabelFromList(radioListWhatToDo, incidentForm?.whatToDo)}
				</span> */}
				<span
					className={pageUtilsForm.classes.answerURB}
					style={{ marginBottom: '15px', fontSize: '15px' }}
				>
					<Text content={pageAssets.request_form_Info_non_dispo} />
				</span>
			</div>
		</>
	)
}

export default DemandeUrbanismeAuComptoirFormDetails
